import React from 'react';
import { Modal } from 'antd';
import { FormattedMessage } from 'react-intl';
import CreditInfoAlert from '../CreditInfo/CreditInfoAlert';
import message from '../../Containers/ManualSearchV2/ManualSearchMessages';

function BulkShortlistModal(props) {
  const {
    visible,
    credits,
    onCloseCreditInfoAlert,
    selectedActiveCandidateCount,
    currentUser,
    isPaidJobServiceEnabled,
    onCancel,
    bulkCandidateShortlist,
    candidateContext,
    availableCredits,
    userConfig,
  } = props;

  const handleSubmit = e => {
    e.preventDefault();
    bulkCandidateShortlist();
  };

  const modalTitle = candidateContext === 'job' ? <FormattedMessage {...message.bulkShortlistLabel} /> : <FormattedMessage {...message.bulkAddLabel} />;
  const text = candidateContext === 'job' ? <FormattedMessage {...message.shortlistLabel} /> : <FormattedMessage {...message.AddLabel} />;
  return (
    <Modal
      title={modalTitle}
      visible={visible}
      onOk={handleSubmit}
      onCancel={onCancel}
      okText={text}
      style={{ width: '26%', minWidth: 600 }}
    >
      <CreditInfoAlert
        credits={credits}
        onCloseCreditInfoAlert={onCloseCreditInfoAlert}
        selectedActiveCandidateCount={selectedActiveCandidateCount}
        currentUser={currentUser}
        isPaidJobServiceEnabled={isPaidJobServiceEnabled}
        statusKey="BulkShortlistCreditInfoAlertStatus"
        candidateContext={candidateContext}
        availableCredits={availableCredits}
        userConfig={userConfig}
        showCreditInfoAlert
      />
    </Modal>
  );
}

export { BulkShortlistModal };
